<div (click)="onWindowClick()" class="calendar-page-container">
  <div class="card modern-card">
    <div class="card-header border-0 bg-transparent pt-3 px-4">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-content">
          <h1 class="modern-header">Appointment Calendar</h1>
        </div>

        <div class="header-actions">
          <button
            type="button"
            class="close-btn"
            (click)="openHome()"
            title="Close"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="card-body p-4">
      <full-calendar [options]="calendarOptions"></full-calendar>
    </div>
  </div>

  <!-- Context Menu -->
  @if (menuState$ | async; as ms) {
    @if (ms.showMenu) {
      <div
        class="custom-context-menu"
        [style.top.px]="ms.menuTop"
        [style.left.px]="ms.menuLeft"
      >
        @if (!ms.event) {
          <div class="menu-item" (click)="addEventFromMenu()">
            <i class="fa-solid fa-plus me-2"></i> Add Event
          </div>
        }
        @if (ms.event) {
          <div class="menu-item" (click)="editEventFromMenu()">
            <i class="fa-solid fa-pen-to-square me-2"></i> Edit Event
          </div>
          <div class="menu-item text-danger" (click)="deleteEventFromMenu()">
            <i class="fa-solid fa-trash-can me-2"></i> <span class="text-light">Delete Event</span>
          </div>
        }
      </div>
    }
  }
</div>
